import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group flex max-w-[124px] cursor-pointer flex-col items-center gap-2 md:max-w-[160px] md:min-w-[100px] md:shrink-0 md:gap-4',
    itemImageWrapper: 'flex-center relative size-19 rounded-full md:size-25',
    itemImageBorder:
      'absolute inset-0 rounded-full transition-opacity group-hover:opacity-50',
    itemImage:
      'absolute w-full max-w-18 rounded-full border-4 object-cover group-hover:border-white md:max-w-23',
    itemText: 'flex flex-col gap-2 text-center',
    itemName: 'heading-xs-bold leading-[120%] tracking-wider uppercase',
    itemTitle: 'heading-s-bold'
  },
  variants: {
    size: {
      base: 'md:w-[125px]',
      s: 'md:w-[140px]',
      sm: 'md:w-[150px]',
      m: 'md:w-[160px]'
    },
    mobileSize: {
      sm: 'w-[90px] shrink-0',
      base: 'w-min',
      m: 'w-min max-w-none min-w-[100px] shrink-0'
    },
    active: {
      true: {
        itemImageWrapper: '-my-1.5 size-22 md:size-28',
        itemImage: 'max-w-21 border-8 border-solid border-white md:max-w-27'
      }
    },
    withoutImageBorder: {
      true: {}
    }
  },
  compoundVariants: [
    {
      active: false,
      withoutImageBorder: true,
      className: {
        itemImage: 'border-none'
      }
    }
  ],
  defaultVariants: {
    size: 'base',
    mobileSize: 'base'
  }
});
